export default {
  baseUrl: 'https://www.experian.co.uk/consumer/product-factsheets',
  basic: 'ExperianAccountOctober2017.pdf',
  credit_expert: 'CreditExpertwithAccountOctober2017.pdf',
  identity: 'identitypluswithaccountjune2018.pdf',
  identity_complimentary: 'Identitypluspartneraug2019.pdf',
};
